import React, {useEffect, useState} from "react";
import {connect} from "react-redux";
import {Container, Row, Table} from "react-bootstrap";
import InvoiceTable from "../InvoiceTable";
import agent from "../../agent";
import {withRouter} from 'react-router-dom';
import {getBill, getOrder, hideBackBtn, removeInvoice, showBackBtn} from "../../actions/actionCreators";
import InvoiceDetails from "../InvoiceDetails";
import i18n from "../../i18nextInitiator";

/**
 * This is the funciton to access translations.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general');

const mapStateToProps = state => ({...state});

const mapDispatchToProps = dispatch => ({
    removeInvoice,
    getOrder,
    getBill,
});

const RepresentativeInvoice = (props) => {
    const [id, setId] = useState(props.match.params.id);

    return (
        <Row style={{margin: "50px 0"}}>
            <Container>
                <h5 style={{margin: "20px 0"}}>{t("invoice.representative")}</h5>
                <InvoiceDetails/>
                <InvoiceTable/>
            </Container>
        </Row>
    );
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(RepresentativeInvoice));